export default __webpack_public_path__ + "static/media/HUD-Effects-HUD Distortion, Lag.15d7c212.jpg";